// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialValues } from './initialValues'

// this will do more once modulations are in place.
const getNewRadioInitialValues = () => {
  return {
    ...initialValues,
    radioModulations: [],
  }
}

export default getNewRadioInitialValues
